export default __webpack_public_path__ + "static/media/primary.aa1c2493105c37c8aac991ec7bee9163.svg";